/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP17_ANSWERS = [
    'Holly is studying spelling rules in her room. Matt and Stephanie bring her some snacks.',
    'Matt sings a song that helps kids remember some tricky spelling.',
    'Stephanie helps Holly with difficult spellings.',
    'Holly is good at spelling, but silent letters are difficult for her, so she studies hard.',
    'At the spelling bee, Holly is in the final with Jenny.',
    'Jenny gets her last word wrong. If Holly gets it right, she will win.',
    'Holly’s last word is “neighbor.” But it’s very difficult to spell.',
    'Then, Holly remembers the song Matt sang. She starts to spell her word.',
    'Holly gets back home. Matt and Stephanie want to know if Holly did well. Of course, she did, she won!',
    'Young Stephanie is in a spelling contest. The word is “raspberry.” If she gets the word correct, she will be the winner.',
    'But Stephanie isn’t sure of the spelling. She thinks and thinks...',
    'Young Matt tries to give Stephanie a clue. Stephanie thinks she understands Matt’s hint.',
    'But, no. Stephanie gets the spelling wrong. She and Matt are disappointed.',
];

// export const HHT1_EP17_ANSWER_SOUNDS = [
//     '/1_EP17_SB_TL_01.mp3',
//     '/1_EP17_SB_TL_02.mp3',
//     '/1_EP17_SB_TL_03.mp3',
//     '/1_EP17_SB_TL_04.mp3',
//     '/1_EP17_SB_TL_05.mp3',
//     '/1_EP17_SB_TL_06.mp3',
//     '/1_EP17_SB_TL_07.mp3',
//     '/1_EP17_SB_TL_08.mp3',
//     '/1_EP17_SB_TL_09.mp3',
//     '/1_EP17_SB_TL_10.mp3',
//     '/1_EP17_SB_TL_11.mp3',
//     '/1_EP17_SB_TL_12.mp3',
//     '/1_EP17_SB_TL_13.mp3',
// ];

export const HHT1_EP17_ANSWER_SOUNDS = [
    '/9415c929de94ec9af97786356a2509c1.mp3',
    '/fa874301a016aacc0c762e234ab7290b.mp3',
    '/5f55664aaf46b1cb02822350acf3be2e.mp3',
    '/4cbb9ac440423ef5a6f4849cf6a04906.mp3',
    '/68499d7881c2bfdcbfe5a2778831b237.mp3',
    '/85761595d5fb1acbb9ec7f2aa1768d5a.mp3',
    '/2f1707c80ed1ccb3c5c429c9907ab0c6.mp3',
    '/783efb57dac78b18e13b3db2f8dc196c.mp3',
    '/8b0abb88677efd26523f71784949fb7e.mp3',
    '/a8e55a93f1d6b555215d4f90a1966502.mp3',
    '/a3b82911b44749472eb7a46c99616af5.mp3',
    '/051f662ad55747ed71eb1edc5c2c3f39.mp3',
    '/a47253a4249abcdd476c61f5cf6bc08e.mp3',
];

export const HHT1_EP17_QUIZ_ITEMS = [{
    'A': HHT1_EP17_ANSWERS[1],
    'B': HHT1_EP17_ANSWERS[10],
    'SoundIndexA': 1,
    'SoundIndexB': 10,
    'answer': HHT1_EP17_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP17_ANSWERS[3],
        'B': HHT1_EP17_ANSWERS[12],
        'SoundIndexA': 3,
        'SoundIndexB': 12,
        'answer': HHT1_EP17_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    {
        'A': HHT1_EP17_ANSWERS[5],
        'B': HHT1_EP17_ANSWERS[0],
        'SoundIndexA': 5,
        'SoundIndexB': 0,
        'answer': HHT1_EP17_ANSWERS[5],
        'sound': [6, 7],
        'exception': false,
    },
    {
        'A': HHT1_EP17_ANSWERS[8],
        'B': HHT1_EP17_ANSWERS[2],
        'SoundIndexA': 8,
        'SoundIndexB': 2,
        'answer': HHT1_EP17_ANSWERS[8],
        'sound': [9, 10],
        'exception': true,
    },
    {
        'A': HHT1_EP17_ANSWERS[4],
        'B': HHT1_EP17_ANSWERS[11],
        'SoundIndexA': 4,
        'SoundIndexB': 11,
        'answer': HHT1_EP17_ANSWERS[11],
        'sound': [12],
        'exception': false,
    },

]
